import { render, staticRenderFns } from "./VerificationCodeImage.vue?vue&type=template&id=72a99de2&scoped=true&"
import script from "./VerificationCodeImage.vue?vue&type=script&lang=ts&"
export * from "./VerificationCodeImage.vue?vue&type=script&lang=ts&"
import style0 from "./VerificationCodeImage.vue?vue&type=style&index=0&id=72a99de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a99de2",
  null
  
)

export default component.exports